import { atomWithStorage } from 'jotai/utils';

type FilterExpandedAtom = ReturnType<typeof atomWithStorage<boolean>>;

const filterExpandedAtoms = new Map<string, FilterExpandedAtom>();

/**
 * Whether a filter is expanded, saved under `storageId`. One atom is kept per filter so every
 * copy of it on screen stays in step. The default is part of the cache key because different
 * configs can share an id and each should keep its own starting state.
 */
export function filterExpandedAtom(
  storageId: string,
  defaultExpanded: boolean,
): FilterExpandedAtom {
  const cacheKey = `${storageId}:${defaultExpanded}`;
  let expandedAtom = filterExpandedAtoms.get(cacheKey);
  if (!expandedAtom) {
    expandedAtom = atomWithStorage(storageId, defaultExpanded, undefined, { getOnInit: true });
    filterExpandedAtoms.set(cacheKey, expandedAtom);
  }
  return expandedAtom;
}
